export default "__VITE_ASSET__B9bDb1lJ__"